
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"playlist play-24px","d":"M4.4 19.64h44.05a4.41 4.41 0 010 8.81H4.4a4.41 4.41 0 010-8.81zM4.4 2h44.05a4.41 4.41 0 010 8.81H4.4A4.41 4.41 0 014.4 2zm0 35.22h26.43a4.41 4.41 0 010 8.81H4.4a4.41 4.41 0 010-8.81zm39.65 3.88v18.67A2.2 2.2 0 0046.24 62a2.25 2.25 0 001.16-.32l15.54-9.34a2.22 2.22 0 00.73-3.06 2.19 2.19 0 00-.73-.72L47.4 39.2a2.23 2.23 0 00-3.35 1.94z"}})])
          )
        }
      }
    